export default "__VITE_ASSET__DHUm9Wn1__"